// Create choice components with options preformatted
// for ease of use in FormControl.

const HVChoiceFormatter = ({
    options,
    optionsDisabled,
    parent: Parent,
    child: Child,
    childProps,
    className,
    ...props
}) => {
    // TO DO:
    // Add version with OptGroups
    if (!Parent) Parent = 'select';
    if (!Child) Child = 'option';
    return (
        <Parent className={className} {...props}>
            {options.map(([value, display], index) => {
                if (!display) display = value;
                const isDisabled = optionsDisabled?.includes(value);
                return (
                    <Child
                        key={index}
                        value={value === null ? '' : value}
                        disabled={isDisabled}
                        {...childProps}
                    >
                        {display}
                    </Child>
                );
            })}
        </Parent>
    );
};

export default HVChoiceFormatter;
